import { render, staticRenderFns } from "./AgentServiceComposer.vue?vue&type=template&id=2064e436&scoped=true"
import script from "./AgentServiceComposer.vue?vue&type=script&lang=js"
export * from "./AgentServiceComposer.vue?vue&type=script&lang=js"
import style0 from "./AgentServiceComposer.vue?vue&type=style&index=0&id=2064e436&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064e436",
  null
  
)

export default component.exports